<template>
  <div id="app">
    <van-nav-bar
      :title="currentTitle"
      left-arrow
      @click-left="onClickLeft"
      v-if="showNavBar"
    />
    <router-view />
    <van-tabbar v-model="active" v-if="showTabBar">
      <van-tabbar-item icon="home-o" to="/">首页</van-tabbar-item>
      <van-tabbar-item icon="apps-o" to="/categories">分类</van-tabbar-item>
      <van-tabbar-item icon="setting-o" to="/settings">设置</van-tabbar-item>
      <van-tabbar-item icon="share-o" to="/share">分享</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import { ref, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'

export default {
  name: 'App',
  setup() {
    const route = useRoute()
    const router = useRouter()
    const active = ref(0)

    const showNavBar = computed(() => route.path !== '/')
    const showTabBar = computed(() => ['/', '/categories', '/settings', '/share'].includes(route.path))
    
    const currentTitle = computed(() => {
      const titles = {
        '/': '核对助手',
        '/categories': '分类管理',
        '/settings': '设置',
        '/share': '分享与协作',
        '/item': '事项详情',
        '/step/edit': '编辑步骤'
      }
      return titles[route.path] || '核对助手'
    })

    const onClickLeft = () => router.back()

    return {
      active,
      showNavBar,
      showTabBar,
      currentTitle,
      onClickLeft
    }
  }
}
</script>

<style>
#app {
  padding-bottom: 0px;
}
</style> 